'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getValue = function getValue(val) {
  return Number.isInteger(val) ? val : '';
};

var parseShorthand = function parseShorthand(_ref) {
  var dark = _ref.dark,
      tint = _ref.tint,
      white = _ref.white;

  if (white) return { background: 'white' };
  if (tint) return { background: 'tint' + getValue(tint) };
  if (dark) return { background: 'dark' };
  return {};
};

var Pane = function Pane(_ref2) {
  var dark = _ref2.dark,
      tint = _ref2.tint,
      white = _ref2.white,
      props = _objectWithoutProperties(_ref2, ['dark', 'tint', 'white']);

  return _react2.default.createElement(_Box2.default, _extends({}, parseShorthand({ dark: dark, tint: tint, white: white }), props));
};

Pane.propTypes = _extends({}, _Box2.default.propTypes, {
  dark: _propTypes2.default.bool,
  tint: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf([1, 2])]),
  white: _propTypes2.default.bool
});

Pane.displayName = 'Pane';

Pane.defaultProps = {
  theme: _theme2.default
};

exports.default = Pane;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Pane.js
// module id = 112
// module chunks = 0